import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateScanTunnelMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input: Types.UpdateScanTunnelInput;
}>;


export type UpdateScanTunnelMutation = { __typename?: 'Mutation', updateScanTunnel: { __typename?: 'ScanTunnel', id: string, name: string, mode: Types.ScanTunnelMode, container_type_id?: number | null } };


export const UpdateScanTunnelDocument = gql`
    mutation UpdateScanTunnel($id: ID!, $input: UpdateScanTunnelInput!) {
  updateScanTunnel(id: $id, input: $input) {
    id
    name
    mode
    container_type_id
  }
}
    `;
export type UpdateScanTunnelMutationFn = Apollo.MutationFunction<UpdateScanTunnelMutation, UpdateScanTunnelMutationVariables>;

/**
 * __useUpdateScanTunnelMutation__
 *
 * To run a mutation, you first call `useUpdateScanTunnelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScanTunnelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScanTunnelMutation, { data, loading, error }] = useUpdateScanTunnelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScanTunnelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScanTunnelMutation, UpdateScanTunnelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScanTunnelMutation, UpdateScanTunnelMutationVariables>(UpdateScanTunnelDocument, options);
      }
export type UpdateScanTunnelMutationHookResult = ReturnType<typeof useUpdateScanTunnelMutation>;
export type UpdateScanTunnelMutationResult = Apollo.MutationResult<UpdateScanTunnelMutation>;
export type UpdateScanTunnelMutationOptions = Apollo.BaseMutationOptions<UpdateScanTunnelMutation, UpdateScanTunnelMutationVariables>;